import { useState } from "react";
import api from "../../../Component/axios";

export const useBitacora = () => {
  const [isLoading, setIsLoading] = useState(false);
  const token = localStorage.getItem("@Token");
  const getBitacora = async (fecha, id_variedad) => {
    setIsLoading(true);
    try {
      const response = await api.get(
        `api/proyeccion-diaria/bitacora/?fecha=${fecha}&variedad=${id_variedad}`,
        {
          headers: {
            Authorization: "Token " + token,
          },
        }
      );
      return response.data;
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  return { getBitacora, isLoading };
};
